import { useTranslation } from 'react-i18next';

import {
  Button,
  ButtonsWrapper,
  Form,
  DatePickerInput,
  Modal,
  SelectInput,
} from '@thinknet-gmbh/platform-common-ui';

import { useCreateAppraisalInterview } from 'src/hooks/appraisal-interview/create-appraisal-interview.hook';
import { useGetAllInterviewTypes } from 'src/hooks/interview-types/get-interview-types.hook';

import { ICreateInterviewProps } from './create-appraisal-interview.interfaces';

const CreateAppraisalInterview = ({ isOpened, onClose, memberId }: ICreateInterviewProps) => {
  const { t, i18n } = useTranslation(['employee', 'common']);

  const { createInterview } = useCreateAppraisalInterview({ onSuccess: onClose });
  const { interviewTypes } = useGetAllInterviewTypes();

  const onFinish = (values: any) => {
    const interviewType = interviewTypes.find((item: any) => item._id === values.interviewTypeId);

    createInterview({
      variables: {
        payload: {
          ...values,
          memberId,
          interviewArticles: interviewType.fieldsHeadlines.map((item: any) => ({ headline: item })),
        },
      },
    });
  };

  return (
    <Modal
      isOpened={isOpened}
      onClose={onClose}
      title={t('employee:employeeInterview.labels.createInterview')}
    >
      <Form layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="interviewTypeId"
          label={t('employee:employeeInterview.labels.interviewType')}
          rules={[
            {
              required: true,
              message: t('employee:employeeInterview.validation.interviewTypeRequired'),
            },
          ]}
        >
          <SelectInput placeholder={t('employee:employeeInterview.labels.salaryReview')}>
            {interviewTypes.map(({ _id, name }: any) => (
              <SelectInput.Option value={_id} key={_id}>
                {name}
              </SelectInput.Option>
            ))}
          </SelectInput>
        </Form.Item>
        <Form.Item
          name="setTo"
          label={t('employee:employeeInterview.labels.setTo')}
          rules={[{ required: true, message: t('employee:validationError.dateRequired') }]}
        >
          <DatePickerInput format="DD.MM.YYYY" lang={i18n.language} />
        </Form.Item>
        <ButtonsWrapper marginTop={16}>
          <Button htmlType="submit" type="primary">
            {t('common:buttons.save')}
          </Button>
          <Button onClick={onClose}>{t('common:buttons.cancel')}</Button>
        </ButtonsWrapper>
      </Form>
    </Modal>
  );
};

export default CreateAppraisalInterview;
